export default Object.freeze({
  Unknown: 0,
  Image: 1,
  Video: 2,
  Pdf: 3,
  Word: 4,
  Excel: 5,
  PowerPoint: 6,
  MicrosoftProject: 7,
  Text: 8,
  Xml: 9,
  Html: 10,
  Json: 11,
  Zip: 12,
  Audio: 13,
  Rar: 14,
  Font: 15,
  TextCsv: 16,
  AndroidApk: 17,
  ExeFile: 18,
  ParquetFile: 19,
  OutlookMessage: 20,
  Markdown: 21,
});
